require("./threepl-service-packages-indication.scss");

import {ChangeDetectionStrategy, Component, computed, inject, input} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {bzIconPackageOutline} from "@bringoz/ui/icons";
import {ThreePLServiceItem} from "../../models/threepl-service-details.model";
import {BringozWeightPipe} from "../../../../commons/angular/pipes/bringoz-weight.pipe";
import {BringozDimensionsPipe} from "../../../../commons/angular/pipes/bringoz-dimensions.pipe";

@Component({
  selector: "app-threepl-service-packages-indication",
  templateUrl: "./threepl-service-packages-indication.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServicePackagesIndicationComponent {
  readonly packages = input.required<ThreePLServiceItem[]>();

  readonly icon = bzIconPackageOutline;

  private readonly translate = inject(TranslateService);
  private readonly weightPipe = new BringozWeightPipe(this.translate, inject("splitService" as never));
  private readonly dimensionsPipe = new BringozDimensionsPipe(this.translate);

  readonly packagesCount = computed(() => {
    const packages = this.packages() ?? [];
    return packages.length ? packages.reduce((sum, item) => sum + item.count, 0) : undefined;
  });

  readonly tooltip = computed(() => (this.packages() ?? []).map((item) => [
    `${item.type ?? ""} X${item.count}`,
    item.barcode,
    item.weight ? this.weightPipe.transform(item.weight, true, "---") : undefined,
    this.dimensionsPipe.transform(item.dimensions, "---"),
    item.requiredSpots ? String(item.requiredSpots) : undefined,
  ].filter((part) => !!part).join(", ")).join("; "));
}
